import { render, staticRenderFns } from "./AnimationButton.vue?vue&type=template&id=669e7e04&scoped=true"
import script from "./AnimationButton.vue?vue&type=script&lang=js"
export * from "./AnimationButton.vue?vue&type=script&lang=js"
import style0 from "./AnimationButton.vue?vue&type=style&index=0&id=669e7e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669e7e04",
  null
  
)

export default component.exports